import { useQuery } from 'react-query'

type ViaCepResponse = {
  cep: string
  logradouro: string
  complemento: string
  bairro: string
  localidade: string
  uf: string
  erro?: boolean
}

const normalizeText = (text: string): string => {
  if (!text) return ''
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
}

const fetchCep = async (cep: string): Promise<ViaCepResponse> => {
  const cleanCep = cep.replace(/\D/g, '')

  if (cleanCep.length !== 8) {
    throw new Error('CEP inválido')
  }

  const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`)
  const data = await response.json()

  if (data.erro) {
    throw new Error('CEP não encontrado')
  }

  return {
    ...data,
    logradouro: normalizeText(data.logradouro),
    complemento: normalizeText(data.complemento),
    bairro: normalizeText(data.bairro),
    localidade: normalizeText(data.localidade)
  }
}

type UseFetchCepParams = {
  cep: string
  enabled?: boolean
}

export function useFetchCep({ cep, enabled = true }: UseFetchCepParams) {
  const cleanCep = cep?.replace(/\D/g, '') || ''

  return useQuery(['viaCep', cleanCep], () => fetchCep(cleanCep), {
    enabled: enabled && cleanCep.length === 8,
    staleTime: 1000 * 60 * 60, // 1 hora
    retry: false
  })
}
